<template>
    <div>
        <el-form class="form" ref="form" label-width="80px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="标记类型" style="margin-bottom:12px;">
                <el-radio-group v-model="data">
                    <el-radio label="horizontalLine">横线(新)</el-radio>
                    <el-radio label="interval">间隔</el-radio>
                    <el-radio label="digital">数字</el-radio>
                    <el-radio label="day">号/天</el-radio>
                    <el-radio label="week">星期</el-radio>
                    <el-radio label="month">月</el-radio>
                    <el-radio label="year">年</el-radio>
                    <el-radio label="separable">离合句</el-radio>
                    <el-radio label="line">横线(老)</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import attributeMixin from '../../mixins/graphic/attribute'
export default {
    name: 'LabelType',
    mixins: [attributeMixin],
    data() {
        return {
            type: 'LabelType',
            default: 0,
        }
    },
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}
</style>